export default {"src":"/_next/static/media/location-icon.1b26838c.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};